export const MAX_IMAGE_WIDTH = 3000;
export const MAX_IMAGE_HEIGHT = 6000;

export const validateImageSize = (
  file: File | Blob,
): Promise<{ valid: boolean; width?: number; height?: number }> => {
  return new Promise((resolve) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      const valid =
        img.width <= MAX_IMAGE_WIDTH && img.height <= MAX_IMAGE_HEIGHT;
      resolve({ valid, width: img.width, height: img.height });
    };

    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      resolve({ valid: false });
    };

    img.src = objectUrl;
  });
};
